import { defineLabels, resolveLabels } from "@nexus/widget-sdk";

export const CAMPAIGN_LIST_LABELS = defineLabels([
  {
    key: "emptyDescription",
    name: "Empty state description",
    default: "Try a different status filter.",
  },
  {
    key: "noEvents",
    name: "Campaign without events",
    default: "No events attached to this campaign.",
  },
  { key: "offStream", name: "Off-stream badge", default: "Off-stream detections" },
  { key: "starts", name: "Campaign start caption", default: "Starts" },
  { key: "ends", name: "Campaign end caption", default: "Ends" },
  { key: "live", name: "Live event badge", default: "Live" },
  { key: "schedule", name: "Event schedule caption", default: "Schedule" },
  { key: "detection", name: "Detection engines caption", default: "Detection" },
  { key: "response", name: "Response engines caption", default: "Response" },
  { key: "notConfigured", name: "No engine configured text", default: "Not configured" },
  { key: "viewProtection", name: "View protection button", default: "View protection" },
  { key: "openMonitor", name: "Open in monitor link", default: "Open in Monitor" },
] as const);

export type CampaignListLabels = ReturnType<typeof resolveLabels<typeof CAMPAIGN_LIST_LABELS>>;
export const DEFAULT_CAMPAIGN_LIST_LABELS: CampaignListLabels = resolveLabels(
  CAMPAIGN_LIST_LABELS,
  undefined,
);
